import { FC } from 'react';

export const ExternalRedirectRoute: FC<{ redirectPath: string }> = ({ redirectPath }) => {
  window.location.replace(redirectPath);
  return null;
};
